import * as yup from 'yup';


export const RegisterSchema = yup.object({
    name: yup
        .string()
        .required('Name is required.')
        .min(5, 'Name must be at least 5 characters long.')
        .matches(
            /^[A-Za-z\s]+$/,
            'Name can only contain letters and spaces'
        ),

    email: yup
        .string()
        .required('Email address is required.')
        .matches(
            /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
            'Please enter a valid email address.'
        ),
    password: yup
        .string()
        .required('Password is required.')
        .min(8, 'Password must be at least 8 characters long.')
        .max(16, 'Password must not exceed 16 characters.')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,16}$/,
            'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., Abc@1234).'
        ),
    confirmPassword: yup
        .string()
        .required('Please confirm your password.')
        .oneOf([yup.ref('password'), null], 'Passwords do not match.'),
    referal: yup
        .string()
        .matches(
            /^[a-zA-Z0-9]*$/, // Only letters and numbers
            'Referral code can only contain letters and numbers'
        )
        .optional(),
    isChecked: yup.boolean()
        .oneOf([true], 'You must agree to the terms and conditions')
});



export const LoginSchema = yup.object({
    email: yup
        .string()
        .required('Email address is required.')
        .matches(
            /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
            'Please enter a valid email address.'
        ),
    password: yup
        .string()
        .required('Password is required.')
        .min(8, 'Password must be at least 8 characters long.')
        .max(16, 'Password must not exceed 16 characters.')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,16}$/,
            'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., Abc@1234).'
        )
});




export const OtpSchema = yup.object().shape({
    otp: yup.string().length(6, "Enter a valid OTP")
});



export const changePasswordSchema = yup.object({
    oldPassword: yup
        .string()
        .required('Old password is required.')
        .min(8, 'Password must be at least 8 characters long.')
        .max(16, 'Password must not exceed 16 characters.')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,16}$/,
            'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., Abc@1234).'
        ),

    newPassword: yup
        .string()
        .required('New password is required.')
        .min(8, 'Password must be at least 8 characters long.')
        .max(16, 'Password must not exceed 16 characters.')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,16}$/,
            'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., Abc@1234).'
        ),

    confirmPassword: yup
        .string()
        .required('Please confirm your new password.')
        .oneOf([yup.ref('newPassword')], 'Passwords do not match.'),
});





export const editProfileSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    phone: yup.string().required("Phone number is required"),
    address: yup.string().required("Address is required"),
    state: yup.string().required("City is required"),
    country: yup.string().required("Country is required"),
    zipCode: yup.string().required("Zip Code is required"),
    image: yup.mixed().required("Image is required"),
});



export const forgotPasswordSchema = yup.object().shape({
    email: yup
        .string()
        .email('Invalid email address')
        .required('Email is required'),
});




export const passwordResetSchema = yup.object().shape({
    otp: yup
        .string()
        .required("OTP is required.")
        .matches(/^[0-9]{6}$/, "OTP must be exactly 6 digits."),

    newPassword: yup
        .string()
        .required("New password is required.")
        .min(8, "Password must be at least 8 characters long.")
        .max(16, "Password must not exceed 16 characters.")
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,16}$/,
            'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character (e.g., Abc@1234).'
        ),

    confirmPassword: yup
        .string()
        .required("Please confirm your password.")
        .oneOf([yup.ref("newPassword")], "Passwords do not match."),
});





export const kycValidationSchema = yup.object().shape({
    first_name: yup.string().required('First name is required'),
    last_name: yup.string().required('Last name is required'),
    phone_no: yup.string()
        .required('Phone number is required')
        .matches(/^[0-9+\-() ]+$/, 'Invalid phone number'),
    gender: yup.string().required('Gender is required'),
    dob: yup.string().required('Date of birth is required'),
    country: yup.string().required('Country is required'),
    state: yup.string().required('State is required'),
    city: yup.string().required('City is required'),
    zipcode: yup.string().required('Zipcode is required'),
    telegram: yup.string().nullable(),
    address: yup.string().required('Address is required'),
    document_type: yup.string().required('Document type is required'),
    document_num: yup.string().required('Document number is required'),
    document_image: yup.string().required('Document image is required'),
    expiry_date: yup.string().nullable(),
    front: yup.string().required('Front side image is required'),
    back: yup.string().required('Back side image is required'),
    selfie: yup.string().nullable(),
    proof_address: yup.string().nullable(),
    residential: yup.string().nullable(),
    termsAccepted: yup
        .boolean()
        .oneOf([true], 'You must accept the terms and conditions'),
});



export const p2pPaymentBankSchema = yup.object().shape({
    Name: yup.string().required("Name is required").min(2, "Name must be at least 2 characters").max(30, "Name must be at most 30 characters"),
    Account_number: yup.string().required("Account Number is required").matches(/^[a-zA-Z0-9]*$/, "Only letters and numbers are allowed"),
    Bank_Name: yup.string().required("Bank Name is required").min(2, "Bank Name must be at least 2 characters").max(30, "Bank Name must be at most 30 characters"),
    Ifsc_code: yup.string().required("IFSC is required").matches(/^[a-zA-Z0-9]+$/, "Only letters and numbers are allowed"),
    Acc_type: yup.string().required("Account Type is required").max(30, "Account type must be at most 30 characters"),
})



export const p2pPaymentUpiandGpaySchema = yup.object().shape({
    Name: yup.string().required("Name is required").min(2, "Name must be at least 2 characters").max(30, "Name must be at most 30 characters"),
    Upi_id: yup.string().required("UPI is required").matches(/^[\w.\-]{2,256}@[a-zA-Z]{2,64}$/, "Enter a valid UPI ID (e.g., name@bank)"),
})
export const p2pPaymentGpaySchema = yup.object().shape({
    Name: yup.string().required("Name is required"),
    Upi_id: yup.string().required("UPI is required"),
})
